import { AuthUserType } from "src/auth/types";
import { IUserItem } from "src/types/user";
import { formatPersonName } from "./global-functions";
export function createUrlFriendlyString(input: string) {
  return input
    .toLowerCase() // Convert to lowercase
    .replace(/[^a-z0-9]/g, ""); // Remove non-alphanumeric characters
}

export function userDisplayName(
  user: Partial<IUserItem> | Partial<AuthUserType>
) {
  return user ? formatPersonName(user.firstName, user.lastName) : "";
}
